import React from "react";
import DashboardIndex from "./DashboardIndex";

export function DashboardPage() {
  return <DashboardIndex />;
}
